import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _MSStateID, _LENDER_VS_CALC_TYPE, _FeeDescription, _DEFAULT_FEE_DESCRIPT, _objectSpread3, _DOC_STAMP_ROUNDING_S;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _invert from 'lodash/invert';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { MSCAN_LOCATIONS } from '../../constants/deal/mscanLocations';
import { INTERNAL_FEE_CODES } from '../../constants/retail/fee.constants';
import { LENDER_RATE_TYPES } from '../../constants/retail/marketScan';
import { DISCLOSURE_TYPES, DISCLOSURE_TYPES_LABELS } from '../../constants/deal/fnis';
export var EXPIRED_PROGRAM_FLAG = 3;
export var getMSStateCodes = function getMSStateCodes() {
  var codeMapper = {};
  MSCAN_LOCATIONS.forEach(function (state) {
    var code = state.code;
    codeMapper[code] = code;
  });
  return codeMapper;
};
export var MSStates = getMSStateCodes();
export var CONFIG_RENDERER_TYPE = {
  SWITCH: 'SWITCH',
  SWITCH_WITH_INPUT: 'SWITCH_WITH_INPUT',
  SELECT: 'SELECT',
  SWITCH_WITH_SELECT: 'SWITCH_WITH_SELECT'
}; // const { SWITCH, SWITCH_WITH_INPUT, SELECT } = CONFIG_RENDERER_TYPE;

var mapStateToOption = function mapStateToOption(_ref) {
  var name = _ref.name,
      code = _ref.code;
  return {
    label: name,
    value: code
  };
};

export var US_STATE_OPTIONS = _map(MSCAN_LOCATIONS, mapStateToOption);
export var MSStateID = (_MSStateID = {}, _defineProperty(_MSStateID, MSStates.AL, 0), _defineProperty(_MSStateID, MSStates.AK, 1), _defineProperty(_MSStateID, MSStates.AZ, 2), _defineProperty(_MSStateID, MSStates.AR, 3), _defineProperty(_MSStateID, MSStates.CA, 4), _defineProperty(_MSStateID, MSStates.CO, 5), _defineProperty(_MSStateID, MSStates.CT, 6), _defineProperty(_MSStateID, MSStates.DE, 7), _defineProperty(_MSStateID, MSStates.FL, 8), _defineProperty(_MSStateID, MSStates.GA, 9), _defineProperty(_MSStateID, MSStates.HI, 10), _defineProperty(_MSStateID, MSStates.ID, 11), _defineProperty(_MSStateID, MSStates.IL, 12), _defineProperty(_MSStateID, MSStates.IN, 13), _defineProperty(_MSStateID, MSStates.IA, 14), _defineProperty(_MSStateID, MSStates.KS, 15), _defineProperty(_MSStateID, MSStates.KY, 16), _defineProperty(_MSStateID, MSStates.LA, 17), _defineProperty(_MSStateID, MSStates.ME, 18), _defineProperty(_MSStateID, MSStates.MD, 19), _defineProperty(_MSStateID, MSStates.MA, 20), _defineProperty(_MSStateID, MSStates.MI, 21), _defineProperty(_MSStateID, MSStates.MN, 22), _defineProperty(_MSStateID, MSStates.MS, 23), _defineProperty(_MSStateID, MSStates.MO, 24), _defineProperty(_MSStateID, MSStates.MT, 25), _defineProperty(_MSStateID, MSStates.NE, 26), _defineProperty(_MSStateID, MSStates.NV, 27), _defineProperty(_MSStateID, MSStates.NH, 28), _defineProperty(_MSStateID, MSStates.NJ, 29), _defineProperty(_MSStateID, MSStates.NM, 30), _defineProperty(_MSStateID, MSStates.NY, 31), _defineProperty(_MSStateID, MSStates.NC, 32), _defineProperty(_MSStateID, MSStates.ND, 33), _defineProperty(_MSStateID, MSStates.OH, 34), _defineProperty(_MSStateID, MSStates.OK, 35), _defineProperty(_MSStateID, MSStates.OR, 36), _defineProperty(_MSStateID, MSStates.PA, 37), _defineProperty(_MSStateID, MSStates.RI, 38), _defineProperty(_MSStateID, MSStates.SC, 39), _defineProperty(_MSStateID, MSStates.SD, 40), _defineProperty(_MSStateID, MSStates.TN, 41), _defineProperty(_MSStateID, MSStates.TX, 42), _defineProperty(_MSStateID, MSStates.UT, 43), _defineProperty(_MSStateID, MSStates.VT, 44), _defineProperty(_MSStateID, MSStates.VA, 45), _defineProperty(_MSStateID, MSStates.WA, 46), _defineProperty(_MSStateID, MSStates.WV, 47), _defineProperty(_MSStateID, MSStates.WI, 48), _defineProperty(_MSStateID, MSStates.WY, 49), _defineProperty(_MSStateID, MSStates.DC, 50), _defineProperty(_MSStateID, MSStates.SA, 51), _defineProperty(_MSStateID, MSStates.SI, 52), _MSStateID);
export var CALIFORNIA_MARKETS = [MSStateID[MSStates.CA], MSStateID[MSStates.SA], MSStateID[MSStates.SI]];
export var isCaliforniaMarket = function isCaliforniaMarket(marketId) {
  return CALIFORNIA_MARKETS.includes(Number(marketId));
};
export var STATE_BY_MARKET_IDS = _invert(MSStateID);
export var stateNameByCode = MSCAN_LOCATIONS.reduce(function (acc, prev) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, prev.code, prev.name));
}, {});

var getStateNameFromCode = function getStateNameFromCode(stateCode) {
  return _get(_find(MSCAN_LOCATIONS, function (_ref2) {
    var code = _ref2.code;
    return code === stateCode;
  }), 'name');
};

export var OPTIONS_FOR_STATE_DROPDOWN = _keys(MSStateID).map(function (stateCode) {
  return {
    label: getStateNameFromCode(stateCode),
    value: MSStateID[stateCode]
  };
});
export var DISCLOSURE_TYPES_OPTIONS = _map(DISCLOSURE_TYPES, function (value, key) {
  return {
    label: DISCLOSURE_TYPES_LABELS[key],
    value: value
  };
});
export var LENDERS = {
  ALLY_FINANCIAL: 'Ally Financial',
  GM_FINANCIAL: 'GM Financial',
  FORD_MOTOR_CREDIT: 'Ford Motor Credit',
  HMF: 'Hyundai Motor Finance',
  KIA: 'Kia Motors Finance',
  GENESIS_FINANCE: 'Genesis Finance'
};
export var LENDER_VS_CALC_TYPE = (_LENDER_VS_CALC_TYPE = {
  DEFAULT: 1
}, _defineProperty(_LENDER_VS_CALC_TYPE, LENDERS.ALLY_FINANCIAL, 4), _defineProperty(_LENDER_VS_CALC_TYPE, LENDERS.FORD_MOTOR_CREDIT, 2), _defineProperty(_LENDER_VS_CALC_TYPE, LENDER_RATE_TYPES.MF, 0), _defineProperty(_LENDER_VS_CALC_TYPE, "BALLOON", 3), _LENDER_VS_CALC_TYPE);
export var FEES_WITH_VALUES = [{
  key: 'numberOfYearsForRegistrationFee',
  dealKey: 'RegistrationYears',
  MSKEY: 'RegistrationYears',
  defaultValue: false,
  defaultInputValue: 2,
  inverseValue: false
}];
export var FEE_OPTIONS_FOR_TARGETING = [{
  label: 'Calculate Registration Fee',
  value: 'calculateRegistrationFee',
  extraKeys: ['waiveRegistrationFee'],
  infoText: null
}, {
  label: 'Calculate Registration Fee for Used Cars',
  value: 'usedVehicleTransferCurrentRegistration',
  extraKeys: [],
  infoText: __('California State Only')
}, {
  label: 'Alt Fuel/Tech Smog Fee',
  value: 'altFuelOrTechSmogFee',
  extraKeys: [],
  infoText: __('California State Only')
}, {
  label: 'Current Smog High Polluter Repair Fee',
  value: 'currentSmogHighPolluterRepairFee',
  extraKeys: [],
  infoText: __('California State Only')
}, {
  label: 'Original Smog Abatement',
  value: 'originalSmogAbatement',
  extraKeys: [],
  infoText: __('California State Only')
}];
export var FEES_WITH_DEPENDENCY_ON_COLLECT_TAX = ['dontAutoApplyExtraTax'];
/**
 * Key Description
 * key :- same as the key outside
 * taxesToMove :- The config for the stateTax flags
 * taxPctToMove :- The config for the TaxPct values
 * invalidStates :- The states where the Option doesn't apply
 */

export var OTHER_GENERAL_OPTIONS = {
  enableInventoryTax: {
    key: 'enableInventoryTax',
    label: 'Always Show VIT Tax',
    taxesToMove: [{
      key: 'vehicleInventoryTaxInCap',
      MSKEY: 'Lease.VehicleInventoryTaxInCap',
      label: 'Collect Inventory Tax in Capped Cost',
      defaultValue: true,
      disable: false,
      paymentType: ['lease']
    }],
    taxPctToMove: [{
      key: 'DealerVehicleInventoryTaxPct',
      otherKeys: {
        dealKey: 'custom.DealerVehicleInventoryTaxPct'
      },
      label: 'Vehicle Inventory Tax',
      paymentType: ['retail', 'lease']
    }],
    invalidStates: [42]
  },
  enableBPOLTax: {
    key: 'enableBPOLTax',
    label: 'Always Show BPOL Tax',
    taxesToMove: [],
    taxPctToMove: [{
      key: 'DealerBPOLTaxPct',
      otherKeys: {
        dealKey: 'custom.DealerBPOLTaxPct'
      },
      label: 'BPOL Tax',
      paymentType: ['retail', 'lease']
    }],
    invalidStates: [45]
  },
  enableWarrantyTax: {
    key: 'enableWarrantyTax',
    label: 'Always Show Warranty Tax',
    taxesToMove: [],
    taxPctToMove: [{
      key: 'DealerWarrantyTaxPct',
      otherKeys: {
        dealKey: 'custom.DealerWarrantyTaxPct'
      },
      label: 'Warranty Tax',
      paymentType: ['retail', 'lease']
    }],
    invalidStates: [45, 46]
  },
  enableOutOfStateLocalBusinessAftermarketTaxPct: {
    key: 'enableOutOfStateLocalBusinessAftermarketTaxPct',
    label: 'Always Show Local Business Aftermarket Tax',
    taxesToMove: [],
    taxPctToMove: [{
      key: 'outOfStateLocalBusinessAftermarketTaxPct',
      otherKeys: {
        dealKey: 'custom.outOfStateLocalBusinessAftermarketTaxPct'
      },
      label: 'Local Business Aftermarket Tax%',
      paymentType: ['retail', 'lease']
    }],
    invalidStates: [41]
  },
  enableStateBusinessTaxPct: {
    key: 'enableStateBusinessTaxPct',
    label: 'Always Show State Business Tax',
    taxesToMove: [],
    taxPctToMove: [{
      key: 'DealerStateBusinessTaxPct',
      otherKeys: {
        dealKey: 'custom.DealerStateBusinessTaxPct'
      },
      label: 'State Business Tax%',
      paymentType: ['retail', 'lease']
    }],
    invalidStates: [41]
  },
  enableLocalBusinessTaxPct: {
    key: 'enableLocalBusinessTaxPct',
    label: 'Always Show Local Business Tax',
    taxesToMove: [],
    taxPctToMove: [{
      key: 'OutOfStateLocalBusinessTaxPct',
      otherKeys: {
        dealKey: 'custom.OutOfStateLocalBusinessTaxPct'
      },
      label: 'Local Business Tax%',
      paymentType: ['retail', 'lease']
    }],
    invalidStates: [41]
  },
  enableLocalAfterMarketTaxPct: {
    key: 'enableLocalAfterMarketTaxPct',
    label: 'Always Show Tax for After Market Products',
    taxesToMove: [],
    taxPctToMove: [{
      key: 'OutOfStateLocalAftermarketTaxPct',
      otherKeys: {
        dealKey: 'custom.OutOfStateLocalAftermarketTaxPct'
      },
      label: 'Local After Market Tax%',
      paymentType: ['retail', 'lease']
    }],
    invalidStates: [41]
  },
  enableFlatTax: {
    key: 'enableFlatTax',
    label: 'Enable Flat Tax',
    taxesToMove: [],
    taxPctToMove: [{
      key: 'FlatTax',
      otherKeys: {
        dealKey: 'custom.FlatTax'
      },
      cannotBeOverridenInDesking: true,
      label: 'Flat Tax',
      paymentType: ['retail']
    }],
    invalidStates: []
  },
  enableExemptAfterMarketProductFromSalesTax: {
    key: 'enableExemptAfterMarketProductFromSalesTax',
    label: 'Exempt After Market Product from Sales Tax',
    taxesToMove: [{
      key: 'outOfStateExemptAfterMarketProductFromSalesTax',
      MSKEY: 'Retail.ExemptAfterMarketProductFromSalesTax',
      label: 'Exempt After Market Product from Sales Tax',
      defaultValue: true,
      disable: false
    }],
    taxPctToMove: [],
    invalidStates: [41]
  },
  enableLease_LocalBusinessTaxUpfront: {
    key: 'enableLease_LocalBusinessTaxUpfront',
    label: 'Local Business Tax Upfront',
    taxesToMove: [{
      key: 'leaseLocalBusinessTaxUpfront',
      MSKEY: 'Lease.LocalBusinessTaxUpfront',
      label: 'Local Business Tax Upfront',
      defaultValue: true,
      disable: false,
      paymentType: ['lease', 'retail']
    }],
    taxPctToMove: [],
    invalidStates: [41]
  },
  enableLease_LocalBusinessAftermarketTaxUpfront: {
    key: 'enableLease_LocalBusinessAftermarketTaxUpfront',
    label: 'Local Business Aftermarket Tax Upfront',
    taxesToMove: [{
      key: 'leaseLocalBusinessAftermarketTaxUpfront',
      MSKEY: 'Lease.LocalBusinessAftermarketTaxUpfront',
      label: 'Local Business Aftermarket Tax Upfront',
      defaultValue: true,
      disable: false,
      paymentType: ['lease']
    }],
    taxPctToMove: [],
    invalidStates: [41]
  },
  enableLease_StateBusinessTaxUpfront: {
    key: 'enableLease_StateBusinessTaxUpfront',
    label: 'Sales Tax Upfront',
    taxesToMove: [{
      key: 'leaseStateBusinessTaxUpfront',
      MSKEY: 'Lease.StateBusinessTaxUpfront',
      label: 'State Business Tax Upfront',
      defaultValue: true,
      disable: false,
      paymentType: ['lease']
    }],
    taxPctToMove: [],
    invalidStates: [41]
  },
  enableIncludeOutOfStateTaxInSalesTax: {
    key: 'enableIncludeOutOfStateTaxInSalesTax',
    label: 'Include Out of State Tax in Sales Tax',
    taxesToMove: [{
      key: 'includeOutOfStateTaxInSalesTax',
      MSKEY: 'Retail.IncludeOutOfStateTaxInSalesTax',
      label: 'Include Out of State Tax in Sales Tax',
      defaultValue: false,
      disable: false
    }],
    taxPctToMove: [],
    invalidStates: [41]
  },
  enableCCRInOnePay: {
    key: 'enableCCRInOnePay',
    label: 'Enable CCR in One Pay',
    taxesToMove: [],
    taxPctToMove: [],
    invalidStates: []
  },
  enableBPOLTaxInCap: {
    key: 'enableBPOLTaxInCap',
    label: 'Make BPOL tax as capped',
    taxesToMove: [],
    taxPctToMove: [],
    invalidStates: []
  }
};
/**
 * Key Description
 * key :- same as the key outside
 * dealKey :- the key where it is stored in deal Object
 * extraKeys :- Keys where the value in dealKey should be copied to before
 *              creating the MSObject
 * isValueType :- These options can be a value instead of percentage if the
 *                value is greater than 100
 * isFlatValue :- If the option is a flat value instead of perccentage
 */

var US_TAX_FEE_CONFIG = [{
  taxes: [{
    key: 'exemptCashFromCCRTax',
    label: 'Collect CCR Tax For Cash',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptCashFromCCRTax',
      dealKey: 'exemptCashFromCCRTax'
    }
  }, {
    key: 'exemptTradeEquityFromCCRTax',
    label: 'Collect CCR Tax For Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptTradeEquityFromCCRTax',
      dealKey: 'exemptTradeEquityFromCCRTax'
    }
  }, {
    key: 'exemptRebateFromCCRTax',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptRebateFromCCRTax',
      dealKey: 'exemptRebateFromCCRTax'
    }
  }, {
    key: 'taxGapInsurance',
    label: 'Tax Gap Insurance',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease', 'retail'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'TaxGapInsurance',
      dealKey: 'taxGapInsurance'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'waiveRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'WaiveRegistrationFee',
      dealKey: 'waiveRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'AZ',
  name: 'Arizona'
}, {
  taxes: [{
    key: 'cityTaxInPayment',
    label: 'Collect City Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CityTaxInPayment',
      dealKey: 'cityTaxInPayment'
    }
  }, {
    key: 'countyTaxInPayment',
    label: 'Collect County Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CountyTaxInPayment',
      dealKey: 'countyTaxInPayment'
    }
  }, {
    key: 'marketIsColoradoSprings',
    label: 'Market Is Colorado Springs',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease', 'retail'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'MarketIsColoradoSprings',
      dealKey: 'marketIsColoradoSprings'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'CityTaxPct',
      extraKeys: []
    }
  }, {
    key: 'CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'CountyTaxPct',
      extraKeys: []
    }
  }, {
    key: 'RTDTaxInPaymentPct',
    enabled: false,
    label: 'RTD Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'RTDTaxInPaymentPct',
      extraKeys: []
    }
  }, {
    key: 'StateTaxInPaymentPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'StateTaxInPaymentPct',
      extraKeys: []
    }
  }],
  code: 'CO',
  name: 'Colorado'
}, {
  taxes: [{
    key: 'dontAutoApplyExtraTax',
    label: 'Collect Luxury Tax',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['retail'],
    inverseValue: true,
    hasDependancyOnCollectTax: true,
    otherKeys: {
      MSKEY: 'DontAutoApplyExtraTax',
      dealKey: 'dontAutoApplyExtraTax'
    }
  }, {
    key: 'exemptCashFromCCRTax',
    label: 'Collect CCR Tax For Cash',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptCashFromCCRTax',
      dealKey: 'exemptCashFromCCRTax'
    }
  }, {
    key: 'exemptRebateFromCCRTax',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptRebateFromCCRTax',
      dealKey: 'exemptRebateFromCCRTax'
    }
  }, {
    key: 'exemptTradeEquityFromCCRTax',
    label: 'Collect CCR Tax For Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptTradeEquityFromCCRTax',
      dealKey: 'exemptTradeEquityFromCCRTax'
    }
  }, {
    key: 'exemptInceptionFeesFromTax',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'exemptInceptionFeesFromTax'
    }
  }, {
    key: 'exemptRegistrationFeeFromTax',
    label: 'Collect Upfront Tax For Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptRegistrationFeeFromTax',
      dealKey: 'exemptRegistrationFeeFromTax'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'registerAsCommercialAndPassengerVehicle',
    label: 'Purchase is Commercial/Passenger Vehicle',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'RegisterAsCommercialAndPassengerVehicle',
      dealKey: 'registerAsCommercialAndPassengerVehicle'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'CT',
  name: 'Connecticut'
}, {
  taxes: [{
    key: 'leaseStateDocFeeInCap',
    label: 'Collect Doc Fee Tax as Capped',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.StateDocFeeInCap',
      dealKey: 'leaseStateDocFeeInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'StateDocFeePct',
    enabled: false,
    label: 'Doc Fee Tax',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'StateDocFeePct',
      extraKeys: []
    }
  }],
  code: 'DE',
  name: 'Delaware'
}, {
  taxes: [{
    key: 'leaseApplyDiscretionarySurtaxCap',
    label: 'Apply Taxation Cap on CCR Taxes',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ApplyDiscretionarySurtaxCap',
      dealKey: 'leaseApplyDiscretionarySurtaxCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'registerElectronically',
    label: 'Register Electronically',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'RegisterElectronically',
      dealKey: 'registerElectronically'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_DocStampRoundingStrategy',
    enabled: false,
    label: 'Rounding Strategy',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_SELECT',
    paymentType: ['retail'],
    cannotBeOverridenInDesking: true,
    otherKeys: {
      dealKey: 'loanTax.DocStampRoundingStrategy',
      extraKeys: []
    }
  }, {
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }],
  code: 'FL',
  name: 'Florida'
}, {
  taxes: [{
    key: 'exemptCashFromCCRTax',
    label: 'Collect CCR Tax For Cash',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptCashFromCCRTax',
      dealKey: 'exemptCashFromCCRTax'
    }
  }, {
    key: 'exemptRebateFromCCRTax',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptRebateFromCCRTax',
      dealKey: 'exemptRebateFromCCRTax'
    }
  }, {
    key: 'exemptTradeEquityFromCCRTax',
    label: 'Collect CCR Tax For Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptTradeEquityFromCCRTax',
      dealKey: 'exemptTradeEquityFromCCRTax'
    }
  }, {
    key: 'leaseIsSellingPriceBased',
    label: 'Collect Tax based on Selling Price',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.IsSellingPriceBased',
      dealKey: 'leaseIsSellingPriceBased'
    }
  }, {
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'GA',
  name: 'Georgia'
}, {
  taxes: [{
    key: 'leaseTaxCashEquityCapCostReduction',
    label: 'Collect Tax on Cash CCR',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxCashEquityCapCostReduction',
      dealKey: 'leaseTaxCashEquityCapCostReduction'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'ID',
  name: 'Idaho'
}, {
  taxes: [{
    key: 'leaseIsSellingPriceBased',
    label: 'Collect Tax based on Selling Price',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.IsSellingPriceBased',
      dealKey: 'leaseIsSellingPriceBased'
    }
  }, {
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'leaseTaxBankFees',
    label: 'Tax Bank Fees',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFees',
      dealKey: 'leaseTaxBankFees'
    }
  }, {
    key: 'taxCappedInterestOnSalesTax',
    label: 'Apply Interest on Capped Sales Tax',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxCappedInterestOnSalesTax',
      dealKey: 'taxCappedInterestOnSalesTax'
    }
  }, {
    key: 'leaseExemptNegativeEquityFromTax',
    label: 'Collect Sales Tax on Negative Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptNegativeEquityFromTax',
      dealKey: 'leaseExemptNegativeEquityFromTax'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Lease_CapCostReductionTaxPct',
    enabled: false,
    label: 'Cap Cost Reduction Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'leaseTax.CapCostReductionTaxPct',
      extraKeys: []
    }
  }, {
    key: 'Lease_UseTaxPct',
    enabled: false,
    label: 'Use Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'leaseTax.UseTaxPct',
      extraKeys: []
    }
  }, {
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }, {
    key: 'RTATaxPct',
    enabled: false,
    label: 'RTA Tax',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.RTATaxPct',
      extraKeys: ['leaseTax.RTATaxPct']
    }
  }],
  code: 'IL',
  name: 'Illinois'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }, {
    key: 'leaseExemptNegativeEquityFromTax',
    label: 'Collect Sales Tax on Negative Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptNegativeEquityFromTax',
      dealKey: 'leaseExemptNegativeEquityFromTax'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'IN',
  name: 'Indiana'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'IA',
  name: 'Iowa'
}, {
  taxes: [{
    key: 'leaseTaxCCRRebate',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxCCRRebate',
      dealKey: 'leaseTaxCCRRebate'
    }
  }, {
    key: 'hasAffidavit',
    label: 'Collect Tax based on Selling Price',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease', 'retail'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'HasAffidavit',
      dealKey: 'hasAffidavit'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'MinimumTaxCharge',
    enabled: false,
    label: 'Minimum Tax Charge',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'MinimumTaxCharge',
      extraKeys: []
    }
  }, {
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'KY',
  name: 'Kentucky'
}, {
  taxes: [{
    key: 'leaseTaxCCRRebate',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxCCRRebate',
      dealKey: 'leaseTaxCCRRebate'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'lienWithUCC',
    label: 'Calculate Lien Fees with UCC',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'LienWithUCC',
      dealKey: 'lienWithUCC'
    }
  }, {
    key: 'retailApplyTradeInCreditAllowance',
    label: 'Apply Trade-in Tax Exemption',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['retail'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Retail.ApplyTradeInCreditAllowance',
      dealKey: 'retailApplyTradeInCreditAllowance'
    }
  }, {
    key: 'leaseNewOrleansParish',
    label: 'Calculate Property Tax for New Orleans',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.NewOrleansParish',
      dealKey: 'leaseNewOrleansParish'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'LA',
  name: 'Louisiana'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'exemptCashFromCCRTax',
    label: 'Collect CCR Tax For Cash',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptCashFromCCRTax',
      dealKey: 'exemptCashFromCCRTax'
    }
  }, {
    key: 'exemptRebateFromCCRTax',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptRebateFromCCRTax',
      dealKey: 'exemptRebateFromCCRTax'
    }
  }, {
    key: 'exemptTradeEquityFromCCRTax',
    label: 'Collect CCR Tax For Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptTradeEquityFromCCRTax',
      dealKey: 'exemptTradeEquityFromCCRTax'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'ME',
  name: 'Maine'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'applyTradeInCreditAllowance',
    label: 'Apply Trade-in Tax Exemption',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['retail', 'lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'ApplyTradeInCreditAllowance',
      dealKey: 'applyTradeInCreditAllowance'
    }
  }, {
    key: 'leaseExemptNegativeEquityFromTax',
    label: 'Collect Sales Tax on Negative Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptNegativeEquityFromTax',
      dealKey: 'leaseExemptNegativeEquityFromTax'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }],
  code: 'MD',
  name: 'Maryland'
}, {
  taxes: [{
    key: 'leaseTaxCCRRebate',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxCCRRebate',
      dealKey: 'leaseTaxCCRRebate'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'MA',
  name: 'Massachusetts'
}, {
  taxes: [{
    key: 'leaseTaxOnBankFeeInCap',
    label: 'Collect Tax on Acquisition Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxOnBankFeeInCap',
      dealKey: 'leaseTaxOnBankFeeInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'collectRecreationPassportFee',
    label: 'Calculate Recreation Passport Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectRecreationPassportFee',
      dealKey: 'collectRecreationPassportFee'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'MI',
  name: 'Michigan'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'exemptCashFromCCRTax',
    label: 'Collect CCR Tax For Cash',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptCashFromCCRTax',
      dealKey: 'exemptCashFromCCRTax'
    }
  }, {
    key: 'exemptTradeEquityFromCCRTax',
    label: 'Collect CCR Tax For Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptTradeEquityFromCCRTax',
      dealKey: 'exemptTradeEquityFromCCRTax'
    }
  }, {
    key: 'leaseExemptNegativeEquityFromTax',
    label: 'Collect Sales Tax on Negative Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptNegativeEquityFromTax',
      dealKey: 'leaseExemptNegativeEquityFromTax'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'MN',
  name: 'Minnesota'
}, {
  taxes: [{
    key: 'retailApplyTradeInCreditAllowance',
    label: 'Apply Trade-in Tax Exemption',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['retail'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Retail.ApplyTradeInCreditAllowance',
      dealKey: 'retailApplyTradeInCreditAllowance'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'NV',
  name: 'Nevada'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'leaseExemptNegativeEquityFromTax',
    label: 'Collect Sales Tax on Negative Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptNegativeEquityFromTax',
      dealKey: 'leaseExemptNegativeEquityFromTax'
    }
  }, {
    key: 'leaseDownPaymentIncludedInSalesTax',
    label: 'DownPayment Included In Sales Tax',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.DownPaymentIncludedInSalesTax',
      dealKey: 'leaseDownPaymentIncludedInSalesTax'
    }
  }, {
    key: 'leaseTaxFullRebateAmount',
    label: 'Tax Full Rebate Amount',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxFullRebateAmount',
      dealKey: 'leaseTaxFullRebateAmount'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'applySupplementalTitleFee',
    label: 'Calculate Supplemental Title Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'DontApplySupplementalTitleFee',
      dealKey: 'applySupplementalTitleFee'
    }
  }, {
    key: 'collectWasteTireFeeOnUsedVehicle',
    label: 'Calculate WasteTire Fee (For Used Vehicles)',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectWasteTireFeeOnUsedVehicle',
      dealKey: 'collectWasteTireFeeOnUsedVehicle'
    }
  }, {
    key: 'calculateWasteTireFee',
    label: 'Calculate WasteTire Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Retail.ExcludeWasteTireFee',
      dealKey: 'calculateWasteTireFee'
    }
  }, {
    key: 'leaseIncludeAcquisitionFeeIntoSupplementalTitleFeeCalc',
    label: 'Include Acquisition Fee Into Supplemental Title Fee Calculation',
    defaultValue: false,
    renderType: 'SWITCH',
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.IncludeAcquisitionFeeIntoSupplementalTitleFeeCalc',
      dealKey: 'leaseIncludeAcquisitionFeeIntoSupplementalTitleFeeCalc'
    }
  }, {
    key: 'leaseSupplementalTitleFeeInCap',
    label: 'Supplemental Title Fee as Capped',
    defaultValue: false,
    renderType: 'SWITCH',
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SupplementalTitleFeeInCap',
      dealKey: 'leaseSupplementalTitleFeeInCap'
    }
  }, {
    key: 'leaseWasteTireFeeInCap',
    label: 'Waste Tire Fee as Capped',
    defaultValue: false,
    renderType: 'SWITCH',
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.WasteTireFeeInCap',
      dealKey: 'leaseWasteTireFeeInCap'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'NJ',
  name: 'New Jersey'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'surchargeOnCappedDownpaymentTax',
    label: 'Apply Surcharge on CCR Tax',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SurchargeOnCappedDownpaymentTax',
      dealKey: 'surchargeOnCappedDownpaymentTax'
    }
  }, {
    key: 'taxCappedInterestOnSalesTax',
    label: 'Apply Interest on Capped Sales Tax',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxCappedInterestOnSalesTax',
      dealKey: 'taxCappedInterestOnSalesTax'
    }
  }, {
    key: 'exemptCashFromCCRTax',
    label: 'Collect CCR Tax For Cash',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptCashFromCCRTax',
      dealKey: 'exemptCashFromCCRTax'
    }
  }, {
    key: 'exemptRebateFromCCRTax',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptRebateFromCCRTax',
      dealKey: 'exemptRebateFromCCRTax'
    }
  }, {
    key: 'exemptTradeEquityFromCCRTax',
    label: 'Collect CCR Tax For Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptTradeEquityFromCCRTax',
      dealKey: 'exemptTradeEquityFromCCRTax'
    }
  }, {
    key: 'exemptInceptionFeesFromTax',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'exemptInceptionFeesFromTax'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'registerAsPassengerVehicle',
    label: 'Purchase is Passenger Vehicle',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'RegisterAsPassengerVehicle',
      dealKey: 'registerAsPassengerVehicle'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }, {
    key: 'calculateWasteTireFee',
    label: 'Calculate WasteTire Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Retail.ExcludeWasteTireFee',
      dealKey: 'calculateWasteTireFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'NY',
  name: 'New York'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'ND',
  name: 'North Dakota'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'OH',
  name: 'Ohio'
}, {
  taxes: [{
    key: 'leaseIsSellingPriceBased',
    label: 'Collect Tax based on Selling Price',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.IsSellingPriceBased',
      dealKey: 'leaseIsSellingPriceBased'
    }
  }, {
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'OK',
  name: 'Oklahoma'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'applyCATTaxToRebate',
    label: 'Apply Corporate Activity Tax to Rebate',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease', 'retail'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ApplyCATTaxToRebate',
      extraKeys: ['Retail.ApplyCATTaxToRebate'],
      dealKey: 'applyCATTaxToRebate'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'enrolledOReGO',
    label: 'Calculate OReGO Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'EnrolledOReGO',
      dealKey: 'enrolledOReGO'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }, {
    key: 'Retail_Lease_CATTaxPct',
    enabled: false,
    label: 'Corporate Activity Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CATTaxPct',
      extraKeys: ['leaseTax.CATTaxPct']
    }
  }],
  code: 'OR',
  name: 'Oregon'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'SC',
  name: 'South Carolina'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'SD',
  name: 'South Dakota'
}, {
  taxes: [{
    key: 'leaseLocalBusinessAftermarketTaxUpfront',
    label: 'Local Business Aftermarket Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.LocalBusinessAftermarketTaxUpfront',
      dealKey: 'leaseLocalBusinessAftermarketTaxUpfront'
    }
  }, {
    key: 'leaseLocalBusinessTaxUpfront',
    label: 'Local Business Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease', 'retail'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.LocalBusinessTaxUpfront',
      dealKey: 'leaseLocalBusinessTaxUpfront'
    }
  }, {
    key: 'leaseLocalSalesTaxUpfront',
    label: 'Sales Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.LocalSalesTaxUpfront',
      dealKey: 'leaseLocalSalesTaxUpfront'
    }
  }, {
    key: 'leaseSalesUseTaxUpfront',
    label: 'Sales Use Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesUseTaxUpfront',
      dealKey: 'leaseSalesUseTaxUpfront'
    }
  }, {
    key: 'leaseStateBusinessTaxUpfront',
    label: 'State Business Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.StateBusinessTaxUpfront',
      dealKey: 'leaseStateBusinessTaxUpfront'
    }
  }, {
    key: 'leaseStateSingleArticleTaxUpfront',
    label: 'Collect Tax Upfront',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.StateSingleArticleTaxUpfront',
      dealKey: 'leaseStateSingleArticleTaxUpfront'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'LocalAftermarketTaxPct',
    enabled: false,
    label: 'Local County Aftermarket Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'LocalAftermarketTaxPct',
      extraKeys: []
    }
  }, {
    key: 'LocalBusinessAftermarketTaxPct',
    enabled: false,
    label: 'Local Business Aftermarket Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'LocalBusinessAftermarketTaxPct',
      extraKeys: []
    }
  }, {
    key: 'LocalBusinessTaxPct',
    enabled: false,
    label: 'Local Business Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'LocalBusinessTaxPct',
      extraKeys: []
    }
  }, {
    key: 'LocalSalesTaxPct',
    enabled: false,
    label: 'Local County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'LocalSalesTaxPct',
      extraKeys: []
    }
  }, {
    key: 'StateAftermarketTaxPct',
    enabled: false,
    label: 'State Aftermarket Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'StateAftermarketTaxPct',
      extraKeys: []
    }
  }, {
    key: 'StateBusinessTaxPct',
    enabled: false,
    label: 'State Business Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'StateBusinessTaxPct',
      extraKeys: []
    }
  }, {
    key: 'StateSingleArticleTaxPct',
    enabled: false,
    label: 'State Single Article Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'StateSingleArticleTaxPct',
      extraKeys: []
    }
  }],
  code: 'TN',
  name: 'Tennessee'
}, {
  taxes: [{
    key: 'leaseNoInventoryTaxOnNewVehicle',
    label: 'Apply Inventory Tax(Lease)',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.NoInventoryTaxOnNewVehicle',
      dealKey: 'leaseNoInventoryTaxOnNewVehicle'
    }
  }, {
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'vehicleInventoryTaxInCap',
    label: 'Collect Inventory Tax in Capped Cost',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.VehicleInventoryTaxInCap',
      dealKey: 'vehicleInventoryTaxInCap'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'numberOfYearsForRegistrationFee',
    label: 'Number Of Years For Registration Fee (Max 2 years)',
    defaultValue: false,
    renderType: 'SWITCH_WITH_INPUT',
    inverseValue: false,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'RegistrationYears',
      dealKey: 'RegistrationYears'
    }
  }],
  taxPercentages: [{
    key: 'VehicleInventoryTaxPct',
    enabled: false,
    label: 'Vehicle Inventory Tax',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.VehicleInventoryTaxPct',
      extraKeys: ['leaseTax.VehicleInventoryTaxPct']
    }
  }, {
    key: 'LenderTaxExempt',
    enabled: false,
    label: 'Lender Tax Credits',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'custom.LenderTaxExempt',
      extraKeys: []
    }
  }, {
    key: 'LendersAndMembersFeePct',
    enabled: false,
    label: 'Lenders and Members Fee %',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'leaseTax.LendersAndMembersFeePct',
      extraKeys: []
    }
  }, {
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'TX',
  name: 'Texas'
}, {
  taxes: [{
    key: 'salesTaxInCap',
    label: 'Collect Sales Tax in Capped Cost',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.SalesTaxInCap',
      dealKey: 'salesTaxInCap'
    }
  }, {
    key: 'leaseTaxBankFee',
    label: 'Apply Tax on Upfront Acquisition Fees',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFees',
      dealKey: 'leaseTaxBankFee'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_WarrantyTaxPct',
    enabled: false,
    label: 'Warranty Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.WarrantyTaxPct',
      extraKeys: ['leaseTax.WarrantyTaxPct']
    }
  }, {
    key: 'BPOLTaxPct',
    enabled: false,
    label: 'Business Tax',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'BPOLTaxPct',
      extraKeys: []
    }
  }, {
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'VA',
  name: 'Virginia'
}, {
  taxes: [{
    key: 'applyCAFTaxExemption',
    label: 'Apply Clean Alternative Fuel (CAF) Tax Exemption',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['retail', 'lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'ApplyCAFTaxExemption',
      dealKey: 'applyCAFTaxExemption'
    }
  }, {
    key: 'rtaTaxApply',
    label: 'Apply Rapid Transit Authority (RTA) Tax',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['retail', 'lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'RTATaxApply',
      dealKey: 'rtaTaxApply'
    }
  }, {
    key: 'collectRTATaxInRegistration',
    label: 'Collect RTA Tax in Registration Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['retail', 'lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectRTATaxInRegistrationFee',
      dealKey: 'collectRTATaxInRegistration'
    }
  }, {
    key: 'leaseTaxBankFee',
    label: 'Apply Tax on Upfront Acquisition Fees',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFees',
      dealKey: 'leaseTaxBankFee'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectDiscoverPassFee',
    label: 'Calculate Discover Pass Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectDiscoverPassFee',
      dealKey: 'collectDiscoverPassFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }, {
    key: 'RTATaxPct',
    enabled: false,
    label: 'RTA Tax',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'RTATaxPct',
      extraKeys: []
    }
  }, {
    key: 'Retail_WarrantyTaxPct',
    enabled: false,
    label: 'Warranty Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.WarrantyTaxPct',
      extraKeys: ['leaseTax.WarrantyTaxPct']
    }
  }],
  code: 'WA',
  name: 'Washington'
}, {
  taxes: [{
    key: 'leaseTaxCCRTradeEquity',
    label: 'Apply tax on Trade Equity being used as Downpayment',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxCCRTradeEquity',
      dealKey: 'leaseTaxCCRTradeEquity'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLoanFilingFee',
    label: 'Calculate Filing Fee(Loans)',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLoanFilingFee',
      dealKey: 'collectLoanFilingFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'WI',
  name: 'Wisconsin'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Lease_CapCostReductionTaxPct',
    enabled: false,
    label: 'Cap Cost Reduction Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'leaseTax.CapCostReductionTaxPct',
      extraKeys: []
    }
  }, {
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'AL',
  name: 'Alabama'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'AK',
  name: 'Alaska'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'AR',
  name: 'Arkansas'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'usedVehicleTransferCurrentRegistration',
    label: 'Calculate Registration Fee for Used Cars',
    defaultValue: false,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'UsedVehicleTransferCurrentRegistration',
      dealKey: 'usedVehicleTransferCurrentRegistration'
    }
  }, {
    key: 'waiveRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'WaiveRegistrationFee',
      dealKey: 'waiveRegistrationFee'
    }
  }, {
    key: 'altFuelOrTechSmogFee',
    label: 'Alt Fuel/Tech Smog Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'AltFuelOrTechSmogFee',
      dealKey: 'altFuelOrTechSmogFee'
    }
  }, {
    key: 'currentSmogHighPolluterRepairFee',
    label: 'Current Smog High Polluter Repair Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CurrentSmogHighPolluterRepairFee',
      dealKey: 'currentSmogHighPolluterRepairFee'
    }
  }, {
    key: 'originalSmogAbatement',
    label: 'Original Smog Abatement',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'OriginalSmogAbatement',
      dealKey: 'originalSmogAbatement'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'CA',
  name: 'California'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'HI',
  name: 'Hawaii'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'KS',
  name: 'Kansas'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'TaxDistrictID',
    enabled: false,
    label: 'Tax District ID',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'TaxDistrictID',
      extraKeys: []
    }
  }, {
    key: 'Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'leaseTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }],
  code: 'MS',
  name: 'Mississippi'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'MO',
  name: 'Missouri'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [],
  code: 'MT',
  name: 'Montana'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'NE',
  name: 'Nebraska'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'NH',
  name: 'New Hampshire'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }, {
    key: 'Lease_SalesUseTaxPct',
    enabled: false,
    label: 'Lease Sales Tax',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['lease'],
    cannotBeOverridenInDesking: true,
    otherKeys: {
      dealKey: 'leaseTax.taxRate',
      extraKeys: []
    }
  }],
  code: 'NM',
  name: 'New Mexico'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'NC',
  name: 'North Carolina'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }, {
    key: 'plateTransferFee',
    label: 'Calculate Plate Transfer Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'PlateTransfer.IsPlateTransfer',
      dealKey: 'plateTransferFee'
    }
  }, {
    key: 'calculateWasteTireFee',
    label: 'Calculate WasteTire Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Retail.ExcludeWasteTireFee',
      dealKey: 'calculateWasteTireFee'
    }
  }],
  taxPercentages: [{
    key: 'MotorVehicleLeaseTaxPct',
    enabled: false,
    label: 'Motor Vehicle Lease Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'MotorVehicleLeaseTaxPct',
      extraKeys: []
    }
  }, {
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'PA',
  name: 'Pennsylvania'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'RI',
  name: 'Rhode Island'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'UT',
  name: 'Utah'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'VT',
  name: 'Vermont'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'WV',
  name: 'West Virginia'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'WY',
  name: 'Wyoming'
}, {
  taxes: [{
    key: 'exemptCashFromCCRTax',
    label: 'Collect CCR Tax For Cash',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptCashFromCCRTax',
      dealKey: 'exemptCashFromCCRTax'
    }
  }, {
    key: 'exemptTradeEquityFromCCRTax',
    label: 'Collect CCR Tax For Trade Equity',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptTradeEquityFromCCRTax',
      dealKey: 'exemptTradeEquityFromCCRTax'
    }
  }, {
    key: 'exemptRebateFromCCRTax',
    label: 'Collect CCR Tax For Rebates',
    defaultValue: true,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.ExemptRebateFromCCRTax',
      dealKey: 'exemptRebateFromCCRTax'
    }
  }, {
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'calculateRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CalculateRegistrationFee',
      dealKey: 'calculateRegistrationFee'
    }
  }, {
    key: 'collectLienFees',
    label: 'Calculate Lien Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CollectLienFees',
      dealKey: 'collectLienFees'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }],
  code: 'DC',
  name: 'District of Columbia'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'usedVehicleTransferCurrentRegistration',
    label: 'Calculate Registration Fee for Used Cars',
    defaultValue: false,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'UsedVehicleTransferCurrentRegistration',
      dealKey: 'usedVehicleTransferCurrentRegistration'
    }
  }, {
    key: 'waiveRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'WaiveRegistrationFee',
      dealKey: 'waiveRegistrationFee'
    }
  }, {
    key: 'altFuelOrTechSmogFee',
    label: 'Alt Fuel/Tech Smog Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'AltFuelOrTechSmogFee',
      dealKey: 'altFuelOrTechSmogFee'
    }
  }, {
    key: 'currentSmogHighPolluterRepairFee',
    label: 'Current Smog High Polluter Repair Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CurrentSmogHighPolluterRepairFee',
      dealKey: 'currentSmogHighPolluterRepairFee'
    }
  }, {
    key: 'originalSmogAbatement',
    label: 'Original Smog Abatement',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'OriginalSmogAbatement',
      dealKey: 'originalSmogAbatement'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'SA',
  name: 'Southern California'
}, {
  taxes: [{
    key: 'taxBankFeesInInceptionFees',
    label: 'Collect Upfront Tax For Acquisition Fee',
    defaultValue: false,
    renderType: 'SWITCH',
    paymentType: ['lease'],
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'Lease.TaxBankFeesInInceptionFees',
      dealKey: 'taxBankFeesInInceptionFees'
    }
  }],
  fees: [{
    key: 'usedVehicleTransferCurrentRegistration',
    label: 'Calculate Registration Fee for Used Cars',
    defaultValue: false,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'UsedVehicleTransferCurrentRegistration',
      dealKey: 'usedVehicleTransferCurrentRegistration'
    }
  }, {
    key: 'waiveRegistrationFee',
    label: 'Calculate Registration Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'WaiveRegistrationFee',
      dealKey: 'waiveRegistrationFee'
    }
  }, {
    key: 'altFuelOrTechSmogFee',
    label: 'Alt Fuel/Tech Smog Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'AltFuelOrTechSmogFee',
      dealKey: 'altFuelOrTechSmogFee'
    }
  }, {
    key: 'currentSmogHighPolluterRepairFee',
    label: 'Current Smog High Polluter Repair Fee',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'CurrentSmogHighPolluterRepairFee',
      dealKey: 'currentSmogHighPolluterRepairFee'
    }
  }, {
    key: 'originalSmogAbatement',
    label: 'Original Smog Abatement',
    defaultValue: true,
    renderType: 'SWITCH',
    inverseValue: true,
    hasDependancyOnCollectTax: false,
    otherKeys: {
      MSKEY: 'OriginalSmogAbatement',
      dealKey: 'originalSmogAbatement'
    }
  }],
  taxPercentages: [{
    key: 'Retail_Lease_StateTaxPct',
    enabled: false,
    label: 'State Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.StateTaxPct',
      extraKeys: ['leaseTax.StateTaxPct']
    }
  }, {
    key: 'Retail_Lease_CountyTaxPct',
    enabled: false,
    label: 'County Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CountyTaxPct',
      extraKeys: ['leaseTax.CountyTaxPct']
    }
  }, {
    key: 'Retail_Lease_CityTaxPct',
    enabled: false,
    label: 'City Tax%',
    defaultValue: 0,
    renderType: 'SWITCH_WITH_INPUT',
    paymentType: ['retail', 'lease'],
    cannotBeOverridenInDesking: false,
    otherKeys: {
      dealKey: 'loanTax.CityTaxPct',
      extraKeys: ['leaseTax.CityTaxPct']
    }
  }],
  code: 'SI',
  name: 'San Diego'
}];
export var GENERAL_SECTION = [{
  sectionName: 'Tax Breakups',
  key: 'taxBreakups',
  configs: [{
    key: 'enableStateTax',
    label: 'State Tax',
    renderType: 'SWITCH',
    otherKeys: {}
  }, {
    key: 'enableCountyTax',
    label: 'County Tax',
    renderType: 'SWITCH',
    otherKeys: {}
  }, {
    key: 'enableCityTax',
    label: 'City Tax',
    renderType: 'SWITCH',
    otherKeys: {}
  }, {
    key: 'enableServiceContractTax',
    label: 'F&I Product Tax',
    renderType: 'SWITCH',
    otherKeys: {}
  }, {
    key: 'enableBusinessTax',
    label: 'Business Tax',
    renderType: 'SWITCH',
    otherKeys: {}
  }]
}, {
  sectionName: 'Lease Setups',
  key: 'leaseSetups',
  configs: [{
    key: 'enableCCRForCapped',
    label: 'Collect CCR Tax in Capped Cost',
    renderType: 'SWITCH',
    otherKeys: {}
  }, {
    key: 'enableCCRInOnePay',
    label: 'Enable CCR in One Pay',
    renderType: 'SWITCH',
    otherKeys: {}
  }, {
    key: 'statesWithTaxOnCappedCustomFeeInLease',
    label: 'Collect Tax on Capped items in Lease',
    renderType: 'SELECT',
    options: [],
    isStateOptions: true,
    otherKeys: {}
  }, {
    key: 'statesWithAcquisitionFeeTax',
    label: 'Collect Tax on Acquisition Fee',
    renderType: 'SELECT',
    isStateOptions: true,
    options: [],
    otherKeys: {}
  }]
}, {
  sectionName: 'Retail Setups',
  key: 'retailSetups',
  configs: [{
    key: 'enableFlatTax',
    label: 'Enable Flat Tax',
    renderType: 'SWITCH_WITH_INPUT',
    otherKeys: {
      inputKey: 'taxPercentages.FlatTax'
    }
  }, {
    key: 'enableStateFlatTax',
    label: 'Enable State Flat Tax',
    renderType: 'SWITCH_WITH_INPUT',
    otherKeys: {
      inputKey: 'taxPercentages.StateFlatTaxValue'
    }
  }, {
    key: 'enableCountyFlatTax',
    label: 'Enable County Flat Tax',
    renderType: 'SWITCH_WITH_INPUT',
    otherKeys: {
      inputKey: 'taxPercentages.CountyFlatTaxValue'
    }
  }, {
    key: 'enableCityFlatTax',
    label: 'Enable City Flat Tax',
    renderType: 'SWITCH_WITH_INPUT',
    otherKeys: {
      inputKey: 'taxPercentages.CityFlatTaxValue'
    }
  }]
}, {
  sectionName: 'Out of State Taxes',
  key: 'outOfStateTaxes',
  subSections: [{
    subSectionName: 'Texas',
    configs: [{
      key: 'enableInventoryTax',
      label: 'Always Show VIT Tax',
      enabled: false,
      renderType: 'SWITCH_WITH_INPUT',
      otherKeys: {
        inputKey: 'taxPercentages.DealerVehicleInventoryTaxPct'
      }
    }]
  }, {
    subSectionName: 'Virginia',
    configs: [{
      key: 'enableBPOLTax',
      label: 'Always Show BPOL Tax',
      enabled: false,
      renderType: 'SWITCH_WITH_INPUT',
      otherKeys: {
        inputKey: 'taxPercentages.DealerBPOLTaxPct'
      }
    }, {
      key: 'enableBPOLTaxInCap',
      label: 'Make BPOL Tax As Capped',
      enabled: false,
      renderType: 'SWITCH',
      otherKeys: {}
    }]
  }, {
    subSectionName: 'Tennessee',
    configs: [{
      key: 'enableOutOfStateLocalBusinessAftermarketTaxPct',
      label: 'Always Show Local Business Aftermarket Tax',
      renderType: 'SWITCH_WITH_INPUT',
      otherKeys: {
        inputKey: 'taxPercentages.outOfStateLocalBusinessAftermarketTaxPct'
      }
    }, {
      key: 'enableStateBusinessTaxPct',
      label: 'Always Show State Business Tax',
      renderType: 'SWITCH_WITH_INPUT',
      otherKeys: {
        inputKey: 'taxPercentages.DealerStateBusinessTaxPct'
      }
    }, {
      key: 'enableLocalBusinessTaxPct',
      label: 'Always Show Local Business Tax',
      renderType: 'SWITCH_WITH_INPUT',
      otherKeys: {
        inputKey: 'taxPercentages.OutOfStateLocalBusinessTaxPct'
      }
    }, {
      key: 'enableLocalAfterMarketTaxPct',
      label: 'Always Show Tax for After Market Products',
      renderType: 'SWITCH_WITH_INPUT',
      otherKeys: {
        inputKey: 'taxPercentages.OutOfStateLocalAftermarketTaxPct'
      }
    }, {
      key: 'enableLease_LocalBusinessTaxUpfront',
      label: 'Local Business Tax Upfront',
      renderType: 'SWITCH',
      otherKeys: {}
    }, {
      key: 'enableLease_LocalBusinessAftermarketTaxUpfront',
      label: 'Local Business Aftermarket Tax Upfront',
      renderType: 'SWITCH',
      otherKeys: {}
    }, {
      key: 'enableLease_StateBusinessTaxUpfront',
      label: 'Sales Tax Upfront',
      renderType: 'SWITCH',
      otherKeys: {}
    }, {
      key: 'enableIncludeOutOfStateTaxInSalesTax',
      label: 'Include Out of State Tax in Sales Tax',
      renderType: 'SWITCH',
      otherKeys: {}
    }, {
      key: 'enableExemptAfterMarketProductFromSalesTax',
      label: 'Exempt After Market Product from Sales Tax',
      renderType: 'SWITCH',
      otherKeys: {}
    }]
  }, {
    subSectionName: 'Virginia/Washington',
    configs: [{
      key: 'enableWarrantyTax',
      label: 'Always Show Warranty Tax',
      enabled: false,
      renderType: 'SWITCH_WITH_INPUT',
      otherKeys: {
        inputKey: 'taxPercentages.DealerWarrantyTaxPct'
      }
    }]
  }]
}, {
  sectionName: 'Miscellaneous Settings',
  key: 'miscellaneousSettings',
  configs: [{
    key: 'statesWithAdjustSellingPriceWithNegativeEquity',
    label: 'Adjust Selling Price With Negative Equity',
    defaultValue: [],
    renderType: 'SELECT',
    isStateOptions: true,
    options: [],
    otherKeys: {}
  }, {
    key: 'disclosureTypesWithSurtax',
    label: 'Collect F&I Products Tax on Following Disclosure Types',
    defaultValue: [],
    renderType: 'SELECT',
    isStateOptions: false,
    options: DISCLOSURE_TYPES_OPTIONS,
    otherKeys: {}
  }, {
    key: 'taxSellingPriceForUsedVehicles',
    label: 'Collect Tax based on Selling Price for Used Vehicles',
    defaultValue: [],
    renderType: 'SELECT',
    isStateOptions: true,
    options: [],
    otherKeys: {}
  }, {
    key: 'taxSellingPriceForNewVehicles',
    label: 'Collect Tax based on Selling Price for New Vehicles',
    defaultValue: [],
    renderType: 'SELECT',
    isStateOptions: true,
    options: [],
    otherKeys: {}
  }, {
    key: 'showDivisionForOwnershipType',
    label: 'Show Division Selection in Trade-in Ownership Type',
    defaultValue: [],
    renderType: 'SELECT',
    isStateOptions: true,
    options: [],
    otherKeys: {}
  }, {
    key: 'showLocationInZipCodeScreen',
    label: 'Show Location in ZIP Code / Tax Rate screen',
    defaultValue: [],
    renderType: 'SELECT',
    isStateOptions: true,
    options: [],
    otherKeys: {}
  }]
}];
export var GENERAL_FEE_SECTIONS = [{
  sectionName: 'General Fees',
  key: 'generalFees',
  configs: [{
    label: 'Calculate Registration Fee in Cap Cost',
    renderType: 'SWITCH',
    key: 'capRegistrationFee',
    options: null,
    otherKeys: {
      uibindKeys: null,
      mskey: null
    }
  }]
}, {
  sectionName: 'Across State Controls',
  key: 'acrossStateControls',
  configs: [{
    label: __('Calculate Registration Fee Across States'),
    key: ['calculateRegistrationFee', 'waiveRegistrationFee'],
    renderType: 'SWITCH'
  }]
}];
export var GENERAL_SECTION_FOR_STATE = {
  // acquisitionFeeTaxable: {
  //   key: 'acquisitionFeeTaxable',
  //   label: 'Acquisition Fee Taxable',
  // },
  taxSellingPriceForUsedVehicles: {
    key: 'taxSellingPriceForUsedVehicles',
    label: 'Collect Tax based on Selling Price for Used Vehicles',
    otherKeys: {
      dealKey: 'hasAffidavit'
    }
  },
  taxSellingPriceForNewVehicles: {
    key: 'taxSellingPriceForNewVehicles',
    label: 'Collect Tax based on Selling Price for New Vehicles',
    otherKeys: {
      dealKey: 'hasAffidavit'
    }
  },
  showDivisionForOwnershipType: {
    key: 'showDivisionForOwnershipType',
    label: 'Show Division Selection in Trade-in Ownership Type'
  }
};
export var GLOBAL_TAX_OPTIONS = {
  enableCCRForCapped: {
    key: 'enableCCRForCapped',
    label: 'Collect CCR Tax in Capped Cost',
    otherKeys: {
      dealKey: 'enableCCRForCapped'
    },
    defaultValue: false
  }
};
var OVERRIDE_REGISTRATION_FEES = {
  ALT_FUEL_OR_TECH_SMOG_FEE: 'ALT_FUEL_OR_TECH_SMOG_FEE',
  CURRENT_SMOG_HIGH_POLLUTER_REPAIR_FEE: 'CURRENT_SMOG_HIGH_POLLUTER_REPAIR_FEE',
  ORIGINAL_SMOG_ABATEMENT: 'ORIGINAL_SMOG_ABATEMENT'
};
export var OVERRIDE_REGISTRATION_FEES_VS_KEY = {
  AltFuelOrTechSmogFee: OVERRIDE_REGISTRATION_FEES.ALT_FUEL_OR_TECH_SMOG_FEE,
  CurrentSmogHighPolluterRepairFee: OVERRIDE_REGISTRATION_FEES.CURRENT_SMOG_HIGH_POLLUTER_REPAIR_FEE,
  OriginalSmogAbatement: OVERRIDE_REGISTRATION_FEES.ORIGINAL_SMOG_ABATEMENT
};
export var FeeDescription = (_FeeDescription = {
  LIEN_FEE: 'Lien Fee',
  LIEN_FEE2: 'Lien Fees To Collect From Lender',
  TITLE_FEE: 'Title Fee',
  TITLE_FEE2: 'Title Certificate Fee',
  LICENCE_FEE: 'Current Vehicle License Fee',
  SMOG_TRANSFER_FEE: 'Smog Transfer Fee',
  WHEELAGE_TAX: 'Wheelage Tax',
  PUBLIC_SAFETY_VEHICLE_FEE: 'Public Safety Vehicle Fee',
  TITLE_FEE3: 'Title Technology Surcharge',
  PLATE_FEE: 'Plate Fee',
  FILING_FEE: 'Filing Fee',
  TRANSFER_TAX: 'Transfer Tax'
}, _defineProperty(_FeeDescription, OVERRIDE_REGISTRATION_FEES.ALT_FUEL_OR_TECH_SMOG_FEE, 'Alt Fuel/Tech Smog Fee'), _defineProperty(_FeeDescription, OVERRIDE_REGISTRATION_FEES.CURRENT_SMOG_HIGH_POLLUTER_REPAIR_FEE, 'Current Smog High Polluter Repair Fee'), _defineProperty(_FeeDescription, OVERRIDE_REGISTRATION_FEES.ORIGINAL_SMOG_ABATEMENT, 'Original Smog Abatement'), _defineProperty(_FeeDescription, "MVET", 'MVET'), _FeeDescription);
export var FEES_THAT_ARE_REGISTRATION_ITEM = [INTERNAL_FEE_CODES.LIEN_FEE, INTERNAL_FEE_CODES.TITLE_FEE, INTERNAL_FEE_CODES.STATE_EMISSION_EXEMPTION_FEE, INTERNAL_FEE_CODES.LICENSE_FEE, INTERNAL_FEE_CODES.REGISTRATION_CHARGES];
var DEFAULT_FEE_DESCRIPTION_INTERNAL_FEE_CODE_MAP = (_DEFAULT_FEE_DESCRIPT = {}, _defineProperty(_DEFAULT_FEE_DESCRIPT, FeeDescription.LIEN_FEE, INTERNAL_FEE_CODES.LIEN_FEE), _defineProperty(_DEFAULT_FEE_DESCRIPT, FeeDescription.LIEN_FEE2, INTERNAL_FEE_CODES.LIEN_FEE), _defineProperty(_DEFAULT_FEE_DESCRIPT, FeeDescription.TITLE_FEE, INTERNAL_FEE_CODES.TITLE_FEE), _defineProperty(_DEFAULT_FEE_DESCRIPT, FeeDescription.TITLE_FEE2, INTERNAL_FEE_CODES.TITLE_FEE), _defineProperty(_DEFAULT_FEE_DESCRIPT, FeeDescription.LICENCE_FEE, INTERNAL_FEE_CODES.LICENSE_FEE), _defineProperty(_DEFAULT_FEE_DESCRIPT, FeeDescription.SMOG_TRANSFER_FEE, INTERNAL_FEE_CODES.STATE_EMISSION_EXEMPTION_FEE), _defineProperty(_DEFAULT_FEE_DESCRIPT, FeeDescription.MVET, INTERNAL_FEE_CODES.RTA_TAXFEE), _DEFAULT_FEE_DESCRIPT);

var STATE_WISE_FEE_DESCRIPTION_INTERNAL_FEE_CODE_MAP = _defineProperty({}, MSStateID[[MSStates.MN]], _objectSpread(_objectSpread({}, DEFAULT_FEE_DESCRIPTION_INTERNAL_FEE_CODE_MAP), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, FeeDescription.WHEELAGE_TAX, INTERNAL_FEE_CODES.WHEELAGE_TAX), _defineProperty(_objectSpread3, FeeDescription.PUBLIC_SAFETY_VEHICLE_FEE, INTERNAL_FEE_CODES.PUBLIC_SAFETY_VEHICLE_FEE), _defineProperty(_objectSpread3, FeeDescription.TITLE_FEE3, INTERNAL_FEE_CODES.TITLE_FEE), _defineProperty(_objectSpread3, FeeDescription.PLATE_FEE, INTERNAL_FEE_CODES.PLATE_TRANSFER_FEE), _defineProperty(_objectSpread3, FeeDescription.FILING_FEE, INTERNAL_FEE_CODES.EV_REGISTRATION), _defineProperty(_objectSpread3, FeeDescription.TRANSFER_TAX, INTERNAL_FEE_CODES.TRANSFER_TAX), _objectSpread3)));

export var FeeDescriptionInternalFeeCodeBasedOnMarketId = function FeeDescriptionInternalFeeCodeBasedOnMarketId(marketId) {
  return STATE_WISE_FEE_DESCRIPTION_INTERNAL_FEE_CODE_MAP[marketId] || DEFAULT_FEE_DESCRIPTION_INTERNAL_FEE_CODE_MAP;
};
export var DOC_STAMP_ROUNDING_STRATEGY = {
  ROUND_UP: 0,
  ROUND_DOWN: 1,
  EXACT: 2
};
export var DOC_STAMP_ROUNDING_STRATEGY_DISPLAY_VALUE = (_DOC_STAMP_ROUNDING_S = {}, _defineProperty(_DOC_STAMP_ROUNDING_S, DOC_STAMP_ROUNDING_STRATEGY.ROUND_UP, 'Round Up'), _defineProperty(_DOC_STAMP_ROUNDING_S, DOC_STAMP_ROUNDING_STRATEGY.ROUND_DOWN, 'Round down'), _defineProperty(_DOC_STAMP_ROUNDING_S, DOC_STAMP_ROUNDING_STRATEGY.EXACT, 'Exact'), _DOC_STAMP_ROUNDING_S);
export var FLAT_TAX_CONFIG = [{
  label: __('State Tax'),
  enabledKey: 'enableStateFlatTax',
  valueKey: 'taxPercentages.StateFlatTaxValue',
  dealKey: 'loanTax.StateFlatTaxValue',
  pctKeysToNullify: ['loanTax.StateTaxPct', 'StateTaxInPaymentPct'],
  paymentType: ['retail']
}, {
  label: __('County Tax'),
  enabledKey: 'enableCountyFlatTax',
  valueKey: 'taxPercentages.CountyFlatTaxValue',
  dealKey: 'loanTax.CountyFlatTaxValue',
  pctKeysToNullify: ['loanTax.CountyTaxPct', 'CountyTaxPct'],
  paymentType: ['retail']
}, {
  label: __('City Tax'),
  enabledKey: 'enableCityFlatTax',
  valueKey: 'taxPercentages.CityFlatTaxValue',
  dealKey: 'loanTax.CityFlatTaxValue',
  pctKeysToNullify: ['loanTax.CityTaxPct', 'CityTaxPct'],
  paymentType: ['retail']
}];
export var USMetaData = {
  stateTaxConfig: US_TAX_FEE_CONFIG,
  generalConfig: {
    taxGeneralConfig: GENERAL_SECTION,
    feeGeneralConfig: GENERAL_FEE_SECTIONS
  },
  separateTaxEnabled: true,
  flatTaxConfig: FLAT_TAX_CONFIG
};